import React from 'react';
import { Paper, Slide } from '@mui/material';
import { ChatAiAssistPanelContent } from './ChatAiAssistPanelContent';
import { ChatAiAssistPanelHeader } from './ChatAiAssistPanelHeader';
import { FIDES_CHAT_PANEL_LAYOUT } from './fidesChatPanelLayout';
import { useChatAiAssistPanelScroll } from './useChatAiAssistPanelScroll';
import { ChatAiAssistState } from '../../hooks/admin/useChatAiAssist';
import { ChatLinkTarget } from '../../utils/chatLinkCorpus';

interface ChatAiAssistPanelProps {
  assist: ChatAiAssistState;
  conversationId: string | null;
  corpus: ChatLinkTarget[] | null;
  /** True when the main chat panel is open and not minimized. */
  chatOpen: boolean;
  /** Prepopulate the admin reply input (does not send). */
  onUseInvestorResponse?: (text: string) => void;
}

export const ChatAiAssistPanel: React.FC<ChatAiAssistPanelProps> = ({
  assist,
  conversationId,
  corpus,
  chatOpen,
  onUseInvestorResponse,
}) => {
  const { scrollRef, latestEntryRef } = useChatAiAssistPanelScroll(assist);

  return (
    <Slide direction="right" in={assist.panelVisible && chatOpen} mountOnEnter unmountOnExit>
      <Paper
        elevation={12}
        sx={{
          position: 'fixed',
          top: FIDES_CHAT_PANEL_LAYOUT.top,
          right: FIDES_CHAT_PANEL_LAYOUT.chatWidth,
          width: FIDES_CHAT_PANEL_LAYOUT.aiAssistWidth,
          height: FIDES_CHAT_PANEL_LAYOUT.height,
          zIndex: FIDES_CHAT_PANEL_LAYOUT.zIndex,
          boxShadow: '0 12px 28px rgba(0, 0, 0, 0.18)',
          borderTopRightRadius: 16,
          borderBottomRightRadius: 16,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: '#f7f9fc',
          borderRight: { sm: '1px solid #e3e8ef' },
        }}
      >
        <ChatAiAssistPanelHeader assist={assist} />
        {assist.mode === 'open' && (
          <ChatAiAssistPanelContent
            assist={assist}
            conversationId={conversationId}
            corpus={corpus}
            scrollRef={scrollRef}
            latestEntryRef={latestEntryRef}
            onUseInvestorResponse={onUseInvestorResponse}
          />
        )}
      </Paper>
    </Slide>
  );
};
